import { render } from "./FooterAdmin.vue?vue&type=template&id=7bd84d5c"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"

import "./FooterAdmin.vue?vue&type=style&index=0&id=7bd84d5c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__